import type { Location } from "react-router";
import { routeChanged } from "state/routeChange";

interface RouterStateLike {
  location: Location;
}

interface CreateRouterNavigationListenerArgs {
  initialLocation: Location;
  dispatch: (action: unknown) => void;
  // Called with the new location on every real navigation, e.g. the
  // service-worker update check.
  onNavigate?: (location: Location) => void;
}

/**
 * Bridges data-router navigation to the redux ROUTE_CHANGED action (which drives
 * leave-page cleanup) and the service-worker update check. Returns a
 * router.subscribe callback that tracks the previous location so it only fires
 * on an actual change, tagging ROUTE_CHANGED with the from/to locations.
 */
export const createRouterNavigationListener = ({
  initialLocation,
  dispatch,
  onNavigate
}: CreateRouterNavigationListenerArgs) => {
  let previousLocation = initialLocation;

  return (state: RouterStateLike) => {
    const nextLocation = state.location;
    if (nextLocation !== previousLocation) {
      dispatch(routeChanged(previousLocation, nextLocation));
      onNavigate?.(nextLocation);
      previousLocation = nextLocation;
    }
  };
};
